
import React from "react";
import ProductCard from "./ProductCard";
import ProductCardNew from "./ProductCardNew";
import "./ProductGrid.css";

const ProductGrid = ({ listings, useNewCard = false }) => {
  const CardComponent = useNewCard ? ProductCardNew : ProductCard;

  return (
    <div className="product-grid-layout">
      {listings.map((product) => {
        const key =
          product.ListingID || product.id || product.ID || product.slug || Math.random();
        return <CardComponent key={key} product={product} />;
      })}
    </div>
  );
};

export default ProductGrid;
